import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "style", "forwardRef"];
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
var Body = function Body(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    forwardRef = _ref.forwardRef,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: forwardRef,
    sectiontype: "container-section",
    className: className,
    style: style
  }, extraProps), children);
};
Body.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string,
  style: PropTypes.object,
  forwardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })])
};
Body.defaultProps = {
  children: null,
  className: null,
  style: null,
  forwardRef: _noop
};
export default Body;